'use client';

import React, { ReactNode } from 'react';
import { cn } from '@/helpers/common';
import Link from 'next/link';

const CategoriesSmallList = ({
  categoriesList,
  classNames,
}: {
  categoriesList: Array<{ route: string; text: string; icon?: ReactNode }>;
  classNames: {
    mainClassName?: string;
    elementClassName: string;
    textClassNames: string;
  };
}) => {
  return (
    <div className={cn('flex justify-center flex-wrap', classNames.mainClassName)}>
      {categoriesList.map((category, index) => (
        <Link
          key={index + category.route}
          href={category.route}
          className={cn(
            'flex flex-col items-center flex-shrink-0 default-transition',
            classNames.elementClassName,
          )}
        >
          {category?.icon}
          <p className={cn('text-center', classNames.textClassNames)}>{category.text}</p>
        </Link>
      ))}
    </div>
  );
};

export default CategoriesSmallList;
